import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import { FAIcon } from './fa-icon/component.js';

var Row = /*#__PURE__*/function (_React$Component) {
  function Row() {
    var _this;

    _classCallCheck(this, Row);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _callSuper(this, Row, [].concat(args));

    _defineProperty(_this, "renderButton", function (props, index) {
      if (props) {
        if (props.action) {
          var disabled = _this.props.disabled || props.disabled;
          return /*#__PURE__*/React.createElement(Button, {
            variant: props.className || 'secondary',
            onClick: !disabled && props.action,
            disabled: disabled,
            key: index
          }, props.icon ? /*#__PURE__*/React.createElement(FAIcon, {
            icon: props.icon
          }) : null, props.label);
        } else {
          return props;
        }
      } else {
        return null;
      }
    });

    return _this;
  }

  _inherits(Row, _React$Component);

  return _createClass(Row, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var disabledStyle = {
        pointerEvents: 'none',
        opacity: 0.5
      };
      var hasRowButtons = this.props.rowButtons && this.props.rowButtons.length;
      var defaultRowClass = 'col-12';

      if (hasRowButtons) {
        defaultRowClass = 'col-10';
      }

      var className = 'row';

      if (this.props.className) {
        className = "".concat(className, " ").concat(this.props.className);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        className: this.props.rowClassName || defaultRowClass,
        style: this.props.disabled ? disabledStyle : null
      }, this.props.children), hasRowButtons ? /*#__PURE__*/React.createElement("div", {
        className: this.props.rowButtonsClassName || 'col-2'
      }, this.props.rowButtons.map(function (rowButton, index) {
        return _this2.renderButton(rowButton, index);
      })) : null);
    }
  }]);
}(React.Component);

_defineProperty(Row, "propTypes", {
  className: PropTypes.string,
  children: PropTypes.any,
  rowClassName: PropTypes.string,
  rowButtonsClassName: PropTypes.string,
  rowButtons: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.func])),
  disabled: PropTypes.bool
});

Row.displayName = "Row";
export { Row };